import {makeStyles} from "@material-ui/core/styles";

export const emptyStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        height: 'calc(100vh - 65px)',
    },
    content: {
        margin: 'auto',
        textAlign: 'center',
    },
    icon: {
        marginBottom: 30,
    },
    typography: {
        marginBottom: 50,
        fontSize: 20,
        maxWidth: 525,
        lineHeight: 1,
        opacity: 0.8,
        fontWeight: 100,
    },
    button: {
        width: 335,
        fontSize: 18,
    }
});
